import BreadCrumbs from "../breadCrumbs"


const MediaCoverageBanner = () => {
    return (
        <div className="relative h-[30vh] md:h-[70vh]  bg-center  overflow-hidden bg-zinc-800 bg-cover  bg-no-repeat bg-[url('')]">
            <div className="absolute inset-0  bg-[rgba(0,0,0,0.2)]"></div>


            <div className="absolute top-1/2  gap-3 flex flex-col items-center left-1/2 -translate-x-1/2 transition-all">
                <h1 className="text-3xl md:text-5xl lg:text-[4rem] whitespace-nowrap font-bold text-white transition-all">News & Events</h1>
                <BreadCrumbs />
            </div>
        </div>
    )
}

export default MediaCoverageBanner